import { render } from "./ok.vue?vue&type=template&id=59f0b6fa&scoped=true&ts=true"
import script from "./ok.vue?vue&type=script&lang=ts"
export * from "./ok.vue?vue&type=script&lang=ts"

import "./ok.vue?vue&type=style&index=0&id=59f0b6fa&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/nonbid_zlysz_com_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59f0b6fa"]])

export default __exports__